<template>
  <div id="app">
    <div v-if="(wording && wording.length > 0) && (submissions && submissions.length)">
      <div class="container-fluid">
        <div class="row">
          <div class="col offset-sm-1 mt-2">
            <img src="./assets/img/banner_left.png" class="img-fluid float-left" width="100%">
          </div>
          <div class="col col-1"></div>
        </div>
      </div>
      <div class="bg-transparent border-bottom-2 border-danger" id="top">
        <nav class="col-10 offset-1 navbar navbar-expand-lg navbar-light pb-0 pl-2 pr-2">
          <ul class="navbar-nav mr-auto mt-lg-0" v-if="login.success === false">
            <li class="nav-item">
              <router-link class="nav-link" to="/login">
                <icon :icon="['fad', 'sign-in-alt']"/>
                Login
              </router-link>
            </li>
          </ul>
          <ul class="navbar-nav mr-auto mt-lg-0" v-if="login.success">
            <li class="nav-item">
              <router-link class="nav-link" to="/home">
                <icon :icon="['fad', 'home']"/>
                {{ wording[0].navigation.home }}
              </router-link>
            </li>
          </ul>
          <ul class="navbar-nav nav-pills" v-if="login.success">
            <li v-if="backlinkUrl !== ''" class="nav-item">
              <a class="nav-link" href="#" v-on:click="showAccount()">
                <icon :icon="['fad', 'id-badge']"/>
                {{ wording[0].navigation.account }}</a>
            </li>
            <li v-else class="nav-item">
              <a class="nav-link" :href="getAccountUrl()">
                <icon :icon="['fad', 'id-badge']"/>
                {{ wording[0].navigation.account }}</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#" v-on:click="logout()">
                <icon :icon="['fad', 'sign-out-alt']"/>
                {{ wording[0].navigation.logout }}</a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="border-bottom border-dark bg-primary d-flex sticky-top">
        <div class="col-10 offset-1 pl-1 pr-1 mx-auto" id="submenu">
          <submission-steps v-if="$route.path.includes('/abstract/')"/>
          <general-navigation v-else></general-navigation>
        </div>
      </div>
      <div class="container-fluid">
        <div class="row" style="min-height: 350px;">
          <div class="col col-lg-10 offset-lg-1 mt-2" v-if="submissions && submissions.length > 0">
            <router-view/>
          </div>
          <div class="col col-lg-10 offset-lg-1 mt-2 text-center" v-else>
            <Loader></Loader>
            Please wait while your submissions are loaded.
          </div>
        </div>
      </div>
      <div class="text-center pt-1 mt-2 pb-1 border-top">
        <div class="mt-3 mb-1">

            <div style="margin-left:auto;margin-right:auto;width:240px;border:1px solid #d4d4d4;border-radius:6px;padding:12px 12px 12px 12px;text-align: center;">
              <a href="https://documedias.com" class="" target="_blank">

              <img src="./assets/img/powered.svg" style="height:20px;">
              </a>
            </div>

        </div>
        <div class="small">
          <a :href="wording[0].navigation.imprint_link" target="_blank" class=""> {{
              wording[0].navigation.imprint
            }} </a> -
          <a :href="wording[0].navigation.datasecurity_link" target="_blank" class="">
            {{ wording[0].navigation.datasecurity }}</a>
        </div>
      </div>

      <div class="modal fade" id="dataUserModal" tabindex="-1" role="dialog" aria-labelledby="dataUserModal"
           aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title text-danger" id="dataUserModal"> {{ wording[0].navigation.user_info }} </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <!--<Speaker submission_id="0" area="home" textkey="modal_dsgvo_text"/>-->
              <span class="font-weight-bold">{{ wording[0].navigation.user_name }}:</span> {{ user.firstName }}
              {{ user.lastName }}<br>
              <span class="font-weight-bold">{{ wording[0].navigation.user_mail }}:</span> {{ user.emailBusiness }}
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-success" data-dismiss="modal">
                {{ wording[0].buttons.back }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class=" d-flex" style="position: fixed;right: 0; bottom: 0; z-index: 1030;">
        <a href="#" v-scroll-to="'#top'" class="ml-auto mr-4 mb-4" title="Scroll to top">
          <icon :icon="['fad', 'arrow-circle-up']" class="fa-2x text-primary"/>
        </a>
      </div>
    </div>
    <Loader v-else></Loader>
  </div>
</template>

<script>
import {mapState, mapActions, mapMutations} from 'vuex'
import GeneralNavigation from "./views/navbars/GeneralNavigation";
import SubmissionSteps from "./views/navbars/SubmissionSteps";
import Loader from './components/Loader';

const VueScrollTo = require('vue-scrollto');

export default {
  components: {GeneralNavigation, SubmissionSteps, Loader},
  computed: mapState([
    'abstracts', 'login', 'submissions', 'language', 'wording', 'user'
  ]),
  mounted() {
    this.$store.dispatch('GET_ALL_STATUS');
    this.$store.dispatch('GET_ALL_TYPES');
    this.$store.dispatch('GET_ALL_SUBMISSIONS');
    this.$store.dispatch('GET_ALL_PAGES');
    this.$store.dispatch('GET_ALL_COUNTRIES');
    this.$store.dispatch('GET_ALL_WORDING', this.language);

    if (!this.user || !this.user.id) {
      this.GET_USERDATA().then((result) => {
        this.SET_USER({user: result.data})
      })
    }

    if (this.login.success === false) {
      this.$router.push('/login');
    }
  },
  data() {
    return {
      backlinkUrl: process.env.VUE_APP_BACKLINK,
    };
  },
  methods: {
    ...mapActions([
      'GET_USERDATA'
    ]),
    ...mapMutations([
      'SET_USER'
    ]),
    getTitle() {
      return process.env.VUE_APP_TITLE
    },
    logout() {
      this.login.success = false;
      localStorage.removeItem('x-api-key');
      if (this.backlinkUrl === "") {
        this.$router.push('/login');
      } else {
        window.location = this.backlinkUrl;
      }


    },
    changeLanguage(language) {
      this.$store.dispatch('GET_ALL_WORDING', language);
    },
    showAccount() {
      $('#dataUserModal').modal('show');
    }
  }
}
</script>

<style lang="scss">
@import './assets/styles/custom-bootstrap.scss';
@import './assets/styles/radial_progress.scss';
@import "~bootstrap/scss/bootstrap";
</style>
